import { ThemeProvider } from '@mui/material';
import {ToastContainer} from 'react-toastify'
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import SplashScreen from './components/screens/SplashScreen';
import { persistor, store } from './store/store';
import darkMode from './themes/dark';
import 'react-toastify/dist/ReactToastify.css'
import './css/main.css';






ReactDOM.render(
  <React.StrictMode>

    <Provider store={store}>
      <PersistGate
        persistor={persistor}
        loading={<SplashScreen/>}
      >
        <ThemeProvider theme={darkMode}>
          <App />
          <ToastContainer />
        </ThemeProvider>
      </PersistGate>
    </Provider>

  </React.StrictMode>,
  document.getElementById('root')
);

